module.exports = "@media (max-width: 992px){\r\n    .category-3d{\r\n        display: none;\r\n    }\r\n}\r\n\r\n#pc-pills-tabContent{\r\n    margin: 0px;\r\n}\r\n\r\n.title{\r\n    text-align: center;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.vintage-dropdown-label{\r\n    text-align: center;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.vintage-dropdown-label>.col-sm-3{\r\n    line-height: 45px;\r\n    padding-right: 0px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/opc/opc-app/partcategory/partcategory.component.css
// module id = ./src/opc/opc-app/partcategory/partcategory.component.css
// module chunks = main